export default __webpack_public_path__ + "static/media/29.967e9d86.jpg";